<div class="radius-dropdown" [attr.disabled]="dropdownConfig.getDisabledValue() || isDisabled" [ngClass]="{'disable-ddn':dropdownConfig.getDisabledValue() || isDisabled}">

  <div class="message text-danger" *ngIf="message">
    {{message}}
  </div>

  <div class="dropdown-button" (click)="toggleDropdownOpenState()" #toggleButton>
    <div class="content" [title]="getSelectedItem" [ngClass]="{'content-placeholder':isPlaceHolder}">
      <span *ngIf="!message">{{getSelectedItem}}</span>
    </div>
    <div class="buttons">
      <i class="fa" [ngClass]="{'fa-caret-down':!isOpen, 'fa-caret-up':isOpen}"></i>
      <i class="fa fa-times" *ngIf="dropdownConfig.getIsClearable()" (click)="onClearingItems()"></i>
    </div>
  </div>


  <div class="dropdown-content" *ngIf="isOpen && !exception" #menu>

    <!--SEARCH-->
    <div class="search" *ngIf="dropdownConfig.getIsSearchable()">
      <div class="search-input">
        <input placeholder="Search" [(ngModel)]="dropdownConfig.searchtext"
          (ngModelChange)="inputModelChanged.next($event)">
      </div>
      <div class="buttons">
        <!-- <i class="fa fa-plus" *ngIf="dropdownConfig.getAddTag()" (click)="onAddTag()"></i> -->
        <i class="fa fa-search"></i>
      </div>
    </div>

    <div class="addTag"
      *ngIf="dropdownConfig.getAddTag() && dropdownConfig.searchtext && dropdownConfig.searchtext.length">
      <div (click)="onAddTag()">
        <i class="fa fa-plus"></i>
        <span class="add-text ms-2">Add "{{dropdownConfig.searchtext}}"</span>
      </div>
    </div>

    <div class="noData-message"
      *ngIf="!dropdownConfig.getLoading() && dropdownConfig.getShowNoData() && items && (items|textFilter: dropdownConfig.searchtext).length === 0">
      No data available for search text "{{dropdownConfig.searchtext}}".
    </div>

    <div class="loading" *ngIf="dropdownConfig.getLoading()">
      Loading ...
    </div>

    <!-- ITEMS-->
    <div class="items" snInfiniteScroll (scrollEnd)="onScroll()" [offset]="10"
      [ngClass]="{'items-loading':dropdownConfig.getLoading(), 'item-selected': areAllSelected}" [attr.disabled]="!dropdownConfig.getLazyLoad()">
      <div class="item" *ngIf="dropdownConfig.getSelectAll() && dropdownConfig.getMultiSelect()">
        <label class="custom-checkbox-button mb-0 d-flex align-items-center" *ngIf="dropdownConfig.getMultiSelect()">
          <input type="checkbox" (change)="onSelectAll()" [checked]="areAllSelected">
          <span></span>
        </label>
        <header class="item-text d-flex align-items-center" (click)="onSelectAll()">Select All</header>
      </div>
      <div class="item" [ngClass]="{'item-selected': isItemPresentInSelection(item)}"
        *ngFor="let item of items | textFilter: dropdownConfig.searchtext">
        <label class="custom-checkbox-button mb-0 d-flex align-items-center" *ngIf="dropdownConfig.getMultiSelect()">
          <input type="checkbox" (change)="onSelect(item)" [checked]="isItemPresentInSelection(item)">
          <span></span>
        </label>
        <header class="item-text d-flex align-items-center" [title]="resolveBindingLabels(item)"
          (click)="onSelect(item)">
          {{resolveBindingLabels(item)}}</header>
      </div>
    </div>
  </div>
</div>
